module.exports = __webpack_public_path__ + "img/KS_Logo_weiss.cb85c26b.png";